// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile.css - Styled Profile Section for Consistency with Triggers */

/* Profile Container */
.profile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  background-color: #f5f5f5; /* Matches the trigger pages */
  border-radius: 10px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15); /* Matches trigger container shadow */
  max-width: 600px;
  width: 100%;
  margin: 20px auto; /* Centers the container with space at the top */
}

/* Profile Header */
h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333; 
  text-align: center;
}

/* Profile Fields */
label {
  display: block;
  font-size: 16px;
  margin-bottom: 7px;
  margin-top: 12px;
  color: #555; 
  text-align: left;
  align-self: flex-start;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  background: white;
}

input:focus {
  border-color: #007bff; /* Matches trigger focus color */
  outline: none;
}

/* Save Button */
button {
  padding: 10px 20px;
  margin-top: 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight: bold;
}

button:hover {
  background-color: #0056b3;
}

/* Message */
.message {
  margin-top: 15px;
  font-size: 14px;
  color: green;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-container {
    width: 90%;
  }
}


.password-requirements {
  font-size: 12px;
  color: #666;
  margin: 8px 0 6px 0;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  align-self: flex-start;
  width: 100%;
  box-sizing: border-box;
  display: none;
}

.password-requirements.visible {
  display: block;
}

.password-requirements ul {
  margin: 5px 0 0 20px;
  padding: 0;
}

.password-requirements li {
  margin: 3px 0;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Profile.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB;EACnB,4CAA4C,EAAE,qCAAqC;EACnF,gBAAgB;EAChB,WAAW;EACX,iBAAiB,EAAE,gDAAgD;AACrE;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,gCAAgC;EACvD,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/* Profile.css - Styled Profile Section for Consistency with Triggers */\n\n/* Profile Container */\n.profile-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 20px;\n  background-color: #f5f5f5; /* Matches the trigger pages */\n  border-radius: 10px;\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15); /* Matches trigger container shadow */\n  max-width: 600px;\n  width: 100%;\n  margin: 20px auto; /* Centers the container with space at the top */\n}\n\n/* Profile Header */\nh2 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #333; \n  text-align: center;\n}\n\n/* Profile Fields */\nlabel {\n  display: block;\n  font-size: 16px;\n  margin-bottom: 7px;\n  margin-top: 12px;\n  color: #555; \n  text-align: left;\n  align-self: flex-start;\n}\n\ninput {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  background: white;\n}\n\ninput:focus {\n  border-color: #007bff; /* Matches trigger focus color */\n  outline: none;\n}\n\n/* Save Button */\nbutton {\n  padding: 10px 20px;\n  margin-top: 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-weight: bold;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n/* Message */\n.message {\n  margin-top: 15px;\n  font-size: 14px;\n  color: green;\n  text-align: center;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profile-container {\n    width: 90%;\n  }\n}\n\n\n.password-requirements {\n  font-size: 12px;\n  color: #666;\n  margin: 8px 0 6px 0;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  align-self: flex-start;\n  width: 100%;\n  box-sizing: border-box;\n  display: none;\n}\n\n.password-requirements.visible {\n  display: block;\n}\n\n.password-requirements ul {\n  margin: 5px 0 0 20px;\n  padding: 0;\n}\n\n.password-requirements li {\n  margin: 3px 0;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
